<!--  -->
<template>
  <div>
    <div class="tinymce_box">
      <div>
        <!-- <div class="tabselecr_box"> -->
        <div class="selectionArea search_box">
          <!-- <div> -->
          <div class="item">
            <el-input
              v-model="obj.keywords"
              clearable
              style="width:280px;"
              placeholder="请输入企业名称/企业id/群主id"
            />
          </div>
          <div class="item">
            <el-input
              v-model="obj.keywords_group"
              clearable
              style="width:280px;"
              placeholder="请输入群聊名称/群聊id"
            />
          </div>
          <div class="item">
            <el-input
              v-model="obj.up_chatroom_id"
              clearable
              style="width:280px;"
              placeholder="请输入由创id"
            />
          </div>
          <div class="item">
            <el-date-picker
              v-model="date"
              type="daterange"
              range-separator="至"
              value-format="yyyy-MM-dd"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            />
          </div>
          <div class="item">
            <el-select
              v-model="obj.onlyMe"
              placeholder="请选择"
            >
              <el-option
                v-for="item in accountarr"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </div>
          <el-button
            type="primary"
            icon="el-icon-search"
            @click="searchclick"
          >搜索</el-button>
          <el-button
            type="info"
            icon="el-icon-refresh-right"
            @click="rechargeclick"
          >重置</el-button>
          <el-button
            type="warning"
            icon="el-icon-download"
            @click="exportexcle"
          >导出</el-button>
        </div>
        <div>
          <!-- <el-button type="success" icon="el-icon-plus" @click="add">新增群聊</el-button> -->
          <!-- <el-button type="success" icon="el-icon-plus" @click="addlink(1)">新增网页跳转</el-button> -->
          <!-- </div> -->
        </div>
        <el-table
          ref="multipleTable"
          v-loading="loading"
          :data="tableData.list"
          border
          tooltip-effect="dark"
          style="width: 100%;margin-top:20px"
          max-height="680"
        >
          <el-table-column
            prop="corp_name_inner"
            label="企业名称"
            align="center"
          />
          <el-table-column
            prop="corp_id"
            label="企业id"
            align="center"
            width="320"
          />
          <el-table-column
            prop="group_chat_owner_name"
            label="群主"
            align="center"
          />
          <el-table-column
            prop="group_chat_name"
            label="群聊名称"
            align="center"
          />
          <el-table-column
            prop="member_num"
            label="人数"
            align="center"
            width="100"
          />
          <el-table-column
            prop="group_chat_id"
            label="群聊id"
            align="center"
            width="320"
          />
          <el-table-column
            prop="up_chatroom_id"
            label="由创id"
            align="center"
          />
          <!-- <el-table-column
            prop="corp_user_names"
            label="发言人"
            align="center"
            width="280"
          >
            <template slot-scope="scope">
              <el-tooltip class="item" effect="dark" :content="scope.row.corp_user_names.toString()" placement="top">
                <div class="spokesman">
                  {{ scope.row.corp_user_names.toString() }}
                </div>
              </el-tooltip>
            </template>
          </el-table-column> -->
          <el-table-column
            align="center"
            prop="status_text"
            width="145"
            label="状态"
          >
            <template slot-scope="scope">
              <i
                v-if="scope.row.group_chat_status == 0"
                class="el-icon-success defaultr"
              />
              <i
                v-if="scope.row.group_chat_status == 1"
                class="el-icon-error stopew"
              />
              <i
                v-if="scope.row.group_chat_status == 2"
                class="el-icon-warning defaultrse"
              />
              <i
                v-if="scope.row.group_chat_status == 3"
                class="el-icon-success fasrw"
              />
              {{ scope.row.status_text }}
            </template>
          </el-table-column>
          <el-table-column
            prop="created_at_text"
            label="创建时间"
            align="center"
            width="155"
          />
          <el-table-column
            label="操作"
            align="center"
            width="300"
          >
            <template slot-scope="scope">
              <el-button
                type="warning"
                :disabled="scope.row.up_chatroom_id === ''"
                size="mini"
                @click="holding(scope.row.up_chatroom_id,scope.row.group_chat_owner)"
              >拉人</el-button>
              <el-button
                type="primary"
                :disabled="scope.row.up_chatroom_id === ''"
                size="mini"
                @click="editcrowd(scope.row)"
              >修改群名称</el-button>
              <el-button
                type="primary"
                size="mini"
                @click="setup(scope.row)"
              >设置发言人</el-button>
            </template>
          </el-table-column>
        </el-table>
        <pagination-right
          :current-page="obj.page"
          :total="tableData.total"
          :page-sizes="[10,20,50,100]"
          @size-change="fetchPageSize"
          @current-change="fetchCurrentPage"
        />
        <el-dialog
          title="新增群聊"
          :visible.sync="dialogVisible"
          :destroy-on-close="true"
          width="35%"
        >
          <wechatband
            ref="wechatbandview"
            @updata="updata"
          />
        </el-dialog>
        <el-dialog
          title="拉人"
          :visible.sync="dialogVisiblepeo"
          :destroy-on-close="true"
          width="30%"
        >
          <dialogall
            ref="dialogallview"
            @updata="updatar"
          />
        </el-dialog>
        <el-dialog
          title="修改群聊名称"
          :visible.sync="dialogVisiblecrowd"
          :destroy-on-close="true"
          width="20%"
        >
          <editcrowdname
            ref="editcrowdnameview"
            @updata="updataase"
          />
        </el-dialog>
        <el-dialog
          title="设置发言人"
          :visible.sync="dialogVisibler"
          :append-to-body="true"
          :close-on-click-modal="false"
          :destroy-on-close="true"
          width="50%"
        >
          <bandstaff
            ref="bandstaffview"
            @bandarr="bandarr"
          />
        </el-dialog>
      </div>

    </div>

  </div>
</template>

<script>
import PaginationRight from '@/components/PaginationRight/index.vue'
import { spMessagelistr, loaddown, setSpokesmanlist, spChatGroupexport } from '@/api/officialaccount.js'
import wechatband from './components/wechatband.vue'
import dialogall from './components/dialogall.vue'
import editcrowdname from './components/editcrowdname.vue'
import bandstaff from './components/bandstaff.vue'
export default {
  name: 'Wechatlist',
  components: { PaginationRight, wechatband, dialogall, editcrowdname, bandstaff },
  data() {
    return {
      tableData: [],
      obj: {
        page: 1,
        pageSize: 10,
        keywords: null,
        keywords_group: null,
        up_chatroom_id: null,
        onlyMe: 2,
        chat_set_id: ''
      },
      dialogTableVisible: false,
      priwdialogVisible: false,
      type: '1',
      options: [],
      loading: false,
      templatedata: [],
      templatetotalre: null,
      plateoption: [],
      palateid: null,
      accountarr: [
        {
          value: 1,
          label: '查看组内群聊'
        },
        {
          value: 2,
          label: '我关联的群聊'
        }
      ],
      dialogVisible: false,
      dialogVisiblepeo: false,
      dialogVisiblecrowd: false,
      dialogVisibler: false,
      spokesman_user_ids: [],
      date: []
    }
  },
  created() {
    // eslint-disable-next-line eqeqeq
    if (this.$route.params.chat_set_id != undefined) {
      this.obj.page = 1
      this.obj.chat_set_id = this.$route.params.chat_set_id
    }
    this.menuList()
  },
  mounted() {},
  activated() {
    console.log('this.$route', this.$route.params.chat_set_id)
    // eslint-disable-next-line eqeqeq
    if (this.$route.params.chat_set_id != undefined) {
      this.obj.page = 1
      this.obj.chat_set_id = this.$route.params.chat_set_id
    }
    this.menuList()
  },
  methods: {
    menuList() {
      this.loading = true
      spMessagelistr({ ...this.obj, created_at_start: this.date && this.date.length ? this.date[0] : null, created_at_end: this.date && this.date.length ? this.date[1] : null }).then(res => {
        this.tableData = res.data
        this.loading = false
      })
    },
    // 分页
    fetchPageSize(e) {
      console.log('222', e)
      this.obj.page = 1
      this.obj.pageSize = e
      this.menuList()
    },
    fetchCurrentPage(e) {
      console.log('111', e)
      this.obj.page = e
      this.menuList()
    },

    rechargeclick() {
      this.obj.page = 1
      this.obj.keywords = null
      this.obj.keywords_group = null
      this.obj.up_chatroom_id = null
      this.obj.onlyMe = 2
      this.obj.chat_set_id = ''
      this.date = []
      this.menuList()
    },
    searchclick() {
      this.obj.page = 1
      this.menuList()
    },
    prwiedit(item) {
      this.priwdialogVisible = true
      setTimeout(() => {
        // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.timepreview.send(item)
      }, 100)
    },

    updata() {
      this.dialogVisible = false
      this.menuList()
    },
    async load(id) {
      const data = await loaddown({
        corp_id: id
      })
      this.$message({
        message: '拉取群聊成功',
        type: 'success'
      })
      this.menuList()
      console.log('data', data)
    },
    add() {
      this.dialogVisible = true
    },
    holding(id, ids) {
      this.dialogVisiblepeo = true
      this.$nextTick(() => {
        this.$refs.dialogallview.sendr(id, ids)
      })
    },
    pullgroup() {},
    updatar() {
      this.dialogVisiblepeo = false
      this.menuList()
    },
    editcrowd(item) {
      this.dialogVisiblecrowd = true
      this.$nextTick(() => {
        this.$refs.editcrowdnameview.send(item)
      })
    },
    updataase() {
      this.dialogVisiblecrowd = false
      this.menuList()
    },
    setup(item) {
      this.dialogVisibler = true
      console.log('item.group_chat_id', item.group_chat_id)
      spMessagelistr({
        page: 1,
        pageSize: 10,
        keywords_group: item.group_chat_id
      }).then(res => {
        console.log('res11111111', res)
        this.$nextTick(() => {
          this.$refs.bandstaffview.sendr(item.group_chat_id, item.corp_id, res.data.list[0].external_users)
        })
      })
      // this.$nextTick(() => {
      //   this.$refs.bandstaffview.sendr(item.group_chat_id, item.corp_id, item.external_users)
      // })
    },
    async bandarr(arr, group_chat_id) {
      this.dialogVisibler = false
      console.log(arr, group_chat_id)
      this.spokesman_user_ids = []
      this.spokesman_user_ids = arr.map(item => {
        return item.wx_id
      })
      const data = await setSpokesmanlist({
        group_chat_id: group_chat_id,
        spokesman_wx_ids: this.spokesman_user_ids
      })
      this.$message({
        message: '设置发言人成功',
        type: 'success'
      })
      this.menuList()
      console.log('data', data)
    },
    exportexcle() {
      if (!this.obj.keywords && !this.obj.keywords_group && !this.obj.up_chatroom_id) {
        this.$message.error('请至少输入一个导出条件')
        return
      }
      this.$confirm('确定要导出吗？ 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      })
        .then(() => {
          spChatGroupexport({
            keywords: this.obj.keywords,
            keywords_group: this.obj.keywords_group,
            up_chatroom_id: this.obj.up_chatroom_id
          }).then(res => {
            console.log('res', res)
            if (res.data.url === '') {
              console.log('空')
            } else {
              this.$message({
                type: 'success',
                message: '导出成功!'
              })
              window.open(res.data.url, '_blank')
            }
          })
        })
        .catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消删除'
          // })
        })
    }
  }
}
</script>
<style scoped lang="less">
.selectionArea {
  display: flex;
  flex-wrap: wrap;
  .item {
    display: flex;
    align-items: center;
    margin-right: 20px;
    .item_title {
      width: 60px;
      display: inline-block;
    }
  }
}
/* @import url(); 引入css类 */
.tinymce_box {
  /* width: 1200px;
  margin: 0 auto;
  margin-top: 50px; */
  padding: 20px;
}
.tinymceserve_box {
  display: flex;
  align-items: center;
  margin-bottom: 30px;
}
.inpuwbox {
  width: 200px;
  margin-left: 20px;
}
.functional_area {
  margin-top: 20px;
}
.tabselecr_box {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.choose_plate {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.choose_text {
  font-size: 14px;
  color: #606266;
}
.template_addbutton {
  text-align: right;
  width: 80%;
}
.sewrw_box {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.search_box {
  display: flex;
  align-items: center;
}
.defaultrse {
  color: #e6a23c;
}
.defaultr {
  color: #67c23a;
}
.stopew {
  color: red;
}
.fasrw {
  color: #409eff;
}
.spokesman {
  max-width: 260px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin: 0 auto;
}
</style>
